/** Returns a French relative-time string for `when` relative to `now` (default: Date.now()). */
export function timeAgo(when, now = Date.now()) {
  const t = typeof when === 'string' ? new Date(when).getTime() : when
  const ms = now - t
  if (ms < 5000) return "à l'instant"
  const fr = new Intl.RelativeTimeFormat('fr', { numeric: 'auto' })
  const sec = Math.floor(ms / 1000)
  if (sec < 60) return fr.format(-sec, 'second')
  const min = Math.floor(sec / 60)
  if (min < 60) return fr.format(-min, 'minute')
  const hr = Math.floor(min / 60)
  if (hr < 24) return fr.format(-hr, 'hour')
  const day = Math.floor(hr / 24)
  return fr.format(-day, 'day')
}
